// 正式
module.exports = {
  title: '充电桩导航',
  APPID: 'xxx',
  APPSECRET: 'xxx',
  $cdn: 'https://xxx/static'
};